module.exports = __webpack_public_path__ + "static/media/timeNewKtm.7598e905.svg";